// extracted by mini-css-extract-plugin
module.exports = {"clickAndCollectCountdown":"ClickAndCollectCountdown_clickAndCollectCountdown__6Ujdq"};